import classNames from 'classnames';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {omit} from 'util/omitKey';

interface TextAreaProps
  extends React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> {
  dataTestAttrs?: DataTestAttrs;
}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>((props, ref) => (
  <textarea
    {...omit(props, 'dataTestAttrs')}
    ref={ref}
    className={classNames(props.className, 'form-control')}
    {...getTestProps(props.dataTestAttrs)}
  />
));

TextArea.displayName = 'TextArea';

export default TextArea;
